import {LtvSelectionType, SecurityTypeSelectionType} from "@portal-workspace/grow-shared-library";

export type SecurityTypeRateValue =
  Record<SecurityTypeSelectionType,
    Record<LtvSelectionType, number>> | null;

